import { useEffect, useRef, useState } from 'react'

/**
 * Text-/Zahlfeld einer Checkliste mit lokalem Entwurf: Tippen wird nie vom Server-Wert überschrieben.
 * Gespeichert wird entprellt (800 ms), beim Verlassen des Feldes und mit Enter.
 * Server-Werte (z. B. 30-s-Aktualisierung) werden nur übernommen, wenn das Feld nicht fokussiert ist
 * und keine ungespeicherte Eingabe vorliegt.
 */
export function ChecklistenEingabe({ wert, onSpeichern, type = 'text', className, placeholder, disabled, inputMode }: {
  wert: string
  onSpeichern: (wert: string) => void
  type?: 'text' | 'number'
  className?: string
  placeholder?: string
  disabled?: boolean
  inputMode?: 'decimal' | 'text'
}) {
  const [entwurf, setEntwurf] = useState(wert)
  const fokus = useRef(false)
  const offen = useRef(false) // ungespeicherte Eingabe
  const timer = useRef<number | null>(null)
  const letzter = useRef(wert)
  const speichernRef = useRef(onSpeichern)
  speichernRef.current = onSpeichern

  useEffect(() => {
    if (!fokus.current && !offen.current) { setEntwurf(wert); letzter.current = wert }
  }, [wert])

  useEffect(() => () => { if (timer.current) window.clearTimeout(timer.current) }, [])

  function speichern(v: string) {
    if (timer.current) { window.clearTimeout(timer.current); timer.current = null }
    if (!offen.current) return
    offen.current = false
    if (v !== letzter.current) { letzter.current = v; speichernRef.current(v) }
  }

  return (
    <input
      type={type}
      inputMode={inputMode}
      value={entwurf}
      disabled={disabled}
      className={className}
      placeholder={placeholder}
      onFocus={() => { fokus.current = true }}
      onChange={e => {
        const v = e.target.value
        setEntwurf(v)
        offen.current = true
        if (timer.current) window.clearTimeout(timer.current)
        timer.current = window.setTimeout(() => speichern(v), 800)
      }}
      onBlur={e => { fokus.current = false; speichern(e.target.value) }}
      onKeyDown={e => { if (e.key === 'Enter') speichern((e.target as HTMLInputElement).value) }}
    />
  )
}
